import React from 'react';
import {
  func,
  node,
} from 'prop-types';
import {
  DrawerHeader,
  IconButton,
  Tooltip
} from '@one-thd/sui-atomic-components';
import {
  Close,
  Refresh
} from '@one-thd/sui-icons';

/**
 * Header for the AssistantDrawer
 *
 * @param { DrawerHeaderProps } props - The properties for the AssistantHeader component.
 * - `onClose`: Function to handle drawer close.
 * - `title`: Drawer's title.
 *
 * @returns {JSX.Element} The AssistantHeader component.
 */
const AssistantHeader = ({
  onClose,
  title,
  onReset = null
}) => {

  return (
    <DrawerHeader
      endAdornment={(
        <>
          {onReset && (
            <IconButton
              aria-label="reset"
              onClick={onReset}
              icon={Refresh}
            />
          )}
          <IconButton
            aria-label="close"
            onClick={onClose}
            icon={Close}
          />
        </>
      )}
      title={title}
    />
  );
};

AssistantHeader.displayName = 'AssistantHeader';

AssistantHeader.propTypes = {
  onClose: func.isRequired,
  title: node.isRequired,
  onReset: func,
};

AssistantHeader.defaultProps = {
  onReset: null,
};

export { AssistantHeader };